// extracted by mini-css-extract-plugin
export default {"Root":"NulsJmqKDzSyiCMtYF5L"};